var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbsArowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.18442 4.13293C0.825444 4.13293 0.534424 4.42395 0.534424 4.78293C0.534424 5.14192 0.825444 5.43293 1.18442 5.43293H9.8804L7.32332 7.99011C7.06947 8.24391 7.06947 8.65541 7.32332 8.90931C7.57716 9.16311 7.98871 9.16311 8.2426 8.90931L11.8983 5.25354C12.0225 5.13515 12.0999 4.96808 12.0999 4.78293C12.0999 4.72123 12.0914 4.66154 12.0753 4.60499C12.074 4.60036 12.0726 4.59574 12.0712 4.59116C12.041 4.49306 11.9872 4.40069 11.9095 4.32307L8.2426 0.656078C7.98871 0.402238 7.57716 0.402238 7.32332 0.656078C7.06947 0.909918 7.06947 1.32147 7.32332 1.57531L9.8809 4.13293H1.18442Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbsArowRight);
export default __webpack_public_path__ + "static/media/breadcrumbs-arow-right.8a0d1e604a999b3ae65e2eaa4e076c77.svg";
export { ForwardRef as ReactComponent };